Ext.define('SA.view.RemoveButton', {
    alias: 'widget.remove-button',
    extend: 'Ext.Component',

    autoEl: 'a',
    baseCls: 'sa-remove-button',
    html: '<svg aria-hidden="true"><use href="#sa-icon-clear"></use></svg>',
    maskOnDisable: false,
    overCls: 'sa-remove-button-over',

    afterRender() {
        this.callParent();

        if (this.tooltip) {
            this.el.set({'data-qtip': this.tooltip});
        }
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClick, this);
    },

    onClick() {
        if (!this.disabled) {
            Ext.callback(this.handler, this.scope || this, [this]);

            this.fireEvent('click', this);
        }
    }
});
